import { token } from '@atlaskit/tokens';
import { Link as PrimitiveLink } from '@atlassian/mpac-primitives';
import { usePartnerPermissions } from '@atlassian/mpac-ui';
import styled from '@emotion/styled';
import React from 'react';

import { TEST_IDS } from '../../../../../../../common/testIds';

type Props = {
  appManageLink: string;
  appShortLink: string;
};

const AdminHeaderLinksContainerV2 = styled.ul({
  padding: 0,
  margin: `0 0 ${token('space.400')}`,
});

const AdminHeaderLinksItem = styled.li({
  display: 'inline',
  '& + &::before': {
    content: "' • '",
  },
});

const AdminHeaderLinks = (props: Props) => {
  const permissions = usePartnerPermissions();

  const { appManageLink, appShortLink } = props;
  const AdminHeaderLinksContainer = AdminHeaderLinksContainerV2;

  return permissions?.canManageAppDetails || permissions?.isMarketplaceReader ? (
    <AdminHeaderLinksContainer data-testid={TEST_IDS.HEADER_ACTION_LINKS}>
      <AdminHeaderLinksItem>
        <PrimitiveLink size="medium" href={appManageLink}>
          Manage app
        </PrimitiveLink>
      </AdminHeaderLinksItem>
      <AdminHeaderLinksItem>
        <PrimitiveLink size="medium" href={appShortLink}>
          Short link
        </PrimitiveLink>
      </AdminHeaderLinksItem>
    </AdminHeaderLinksContainer>
  ) : null;
};

export default AdminHeaderLinks;
